
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const ValidationPopUp = ({ openModal, handleClose, contentText }) => {

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >

            <DialogTitle style={{ textAlign: "center" }}>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 10,
                        color: "grey",
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <p style={{ textAlign: "center", marginTop: 20, paddingLeft: 40, paddingRight: 40, paddingTop: 20, paddingBottom: 20 }}>{contentText}</p>
            </DialogContent>
        </Dialog>

    )
}

export default ValidationPopUp;